// A file name may not be reused for a level 1 resource: it must not collide with any prior
// upload (draft, partially completed or completed — status is irrelevant). The in-progress
// draft is deliberately not checked: its name only ever equals the file being validated
// (it's set from that same file at parse time), so checking it self-matches every fresh file.
export const isFileNameAlreadyUsed = (
  fileName: string,
  uploads: Array<{ fileName?: string | null }>,
): boolean => uploads.some(u => u?.fileName === fileName);
